export class UserAvatarUpdatedMessage {
  constructor(
    public readonly userName: string | null,
    public readonly avatar: string | null,
  ) {}
}